Page buyPage
	title = "Kaufen"
	showFor = [Business, Admin]
	needsAuth = true
	
	// Filter state
	bool[string][string]	checkedValues = {}	// fieldName -> value -> isChecked
	float[string]	rangeMin = {}	// fieldName -> min value
	float[string]	rangeMax = {}	// fieldName -> max value
	string[][string]	distinctValues = {}	// fieldName -> list of distinct values
	int[string][string]	valueCounts = {}	// fieldName -> value -> count in goods

	show: string id = ""
		html.setTitle title + app.titleSuffix
		await app.goods.subscribe "state = 'Auction'"
		if not Platform.isDebug then await app.actions.add {actionType:ViewBuyPage, user:app.user.id}
		initializeFilters
		refresh

	hide
		await app.goods.unsubscribe

	tick
		if app.goods.length > 0 then refresh

	initializeFilters
		checkedValues.clear
		rangeMin.clear
		rangeMax.clear
		distinctValues.clear
		valueCounts.clear
		
		for app.fields as field
			if field.filterType == None then continue
			let fieldName = field.fieldName
			if not fieldName then continue
			
			if field.filterType == Checkboxes
				// Collect distinct values and counts from goods
				string[] values = []
				int[string] counts = {}
				for app.goods as good
					let value = good[fieldName]
					if value and value != ""
						if not values.contains(value)
							values.add value
						counts[value] = (counts[value] or 0) + 1
				
				distinctValues[fieldName] = values
				valueCounts[fieldName] = counts
				
				// Initialize all as checked
				bool[string] checked = {}
				for values as value
					checked[value] = true
				checkedValues[fieldName] = checked
				
			else if field.filterType == Range
				// Initialize with actual min/max from goods
				float minValue = float.maxValue
				float maxValue = float.minValue
				for app.goods as good
					let value = (float)good[fieldName]
					if value and value.isValidNumber
						if value < minValue then minValue = value
						if value > maxValue then maxValue = value
				rangeMin[fieldName] = minValue != float.maxValue ? minValue : (field.minNumber or 0)
				rangeMax[fieldName] = maxValue != float.minValue ? maxValue : (field.maxNumber or float.maxValue)

	getFilteredGoods
		Good[] result = []
		for app.goods as good
			if matchesAllFilters(good)
				result.add good
				let msg = app.messages.items.findLast.good == good.id
					good.order = msg.category == ActionRequired ? "_" + msg.created : msg.created
				else
					good.order = good.auctionEndTime
		result.orderBy.order
		return result

	matchesAllFilters: Good good
		for app.fields as field
			if field.filterType == None then continue
			let fieldName = field.fieldName
			if not fieldName then continue
			
			if field.filterType == Checkboxes
				let value = good[fieldName]
				let checked = checkedValues[fieldName]
				// If value exists and is unchecked, exclude this good
				if value and checked and checked[value] == false
					return false
					
			else if field.filterType == Range
				let value = (float)good[fieldName]
				let min = rangeMin[fieldName]
				let max = rangeMax[fieldName]
				// If value is outside range, exclude this good
				if value and value.isValidNumber
					if min and value < min then return false
					if max and value > max then return false
		
		return true

	draw
		div display:flex, justifyContent:center, padding:{top:40}
			if app.goods.length == 0
				div text:"Zur Zeit laufen keine Auktionen.", fontSize:18, fontWeight:bold, color:lightGray
			else
			if isMobile
				drawList
			else
				div width:1200, display:flex, gap:28, alignItems:flexStart
					drawFilters
					drawList

	drawFilters
		div width:280, backgroundColor:#ffffff, borderRadius:20, padding:{top:24 bottom:24 left:24 right:24}, boxShadow:{offset:{0,10}, blur:40, spread:0, color:#dfe4ef}, display:flex, flexDirection:column, gap:28
			for app.fields as field
				if field.filterType == Checkboxes
					drawCheckboxFilter field
			for app.fields as field
				if field.filterType == Range
					drawRangeFilter field

	drawCheckboxFilter: Field field
		let fieldName = field.fieldName
		if not fieldName then return
		let values = distinctValues[fieldName]
		let counts = valueCounts[fieldName]
		let checked = checkedValues[fieldName]
		
		if not values or values.length == 0 then return
		
		div display:flex, flexDirection:column, gap:16
			div text:field.name, fontSize:18, fontWeight:bold, color:#2b3145
			for values as value
				let isChecked = checked and checked[value]
				let count = counts ? (counts[value] or 0) : 0
				div display:flex, alignItems:center, justifyContent:spaceBetween, cursor:pointer
					onClick:
						checkedValues[fieldName][value] = not checkedValues[fieldName][value]
						refresh
					div display:flex, alignItems:center, gap:14
						drawCheckbox isChecked
						div text:value, fontSize:15, color:#40465a, fontWeight:isChecked ? bold : normal
					div text:"({count})", fontSize:14, color:#7a8195

	drawRangeFilter: Field field
		let fieldName = field.fieldName
		if not fieldName then return
		let unit = field.unit or ""
		let currentMin = rangeMin[fieldName]
		let currentMax = rangeMax[fieldName]
		
		div display:flex, flexDirection:column, gap:16
			div text:field.name, fontSize:18, fontWeight:bold, color:#2b3145
			div display:flex, gap:12, alignItems:center
				div display:flex, flexDirection:column, gap:4, flex:1
					div text:"Von", fontSize:12, color:#7a8195
					div position:relative
						input width:100%, value:currentMin.isValidNumber ? currentMin.toString : ""
							borderRadius:8, border:{1px solid #d1d5db}, padding:{8 12}
							fontSize:14, color:#2b3145, outline:none
							styleWhenFocused: {border:{1px solid primaryColor}}
						onInput: inputValue =>
							let floatValue = inputValue.toFloat
							if floatValue.isValidNumber
								rangeMin[fieldName] = floatValue
								refresh
						if unit then div text:unit, fontSize:14, color:#7a8195, position:absolute, right:12, top:6
				div display:flex, flexDirection:column, gap:4, flex:1
					div text:"Bis", fontSize:12, color:#7a8195
					div position:relative
						input width:100%, value:currentMax.isValidNumber ? currentMax.toString : ""
							borderRadius:8, border:{1px solid #d1d5db}, padding:{8 12}
							fontSize:14, color:#2b3145, outline:none
							styleWhenFocused: {border:{1px solid primaryColor}}
						onInput: inputValue =>
							let floatValue = inputValue.toFloat
							if floatValue.isValidNumber
								rangeMax[fieldName] = floatValue
								refresh
						if unit then div text:unit, fontSize:14, color:#7a8195, position:absolute, right:12, top:6

	drawCheckbox: bool isActive
		div width:18, height:18, borderRadius:6, border:{width:2px, style:solid, color:isActive ? primaryColor : #ccd2e1}, backgroundColor:isActive ? primaryColor : #ffffff, display:flex, alignItems:center, justifyContent:center, color:#ffffff, fontSize:12
			if isActive
				div text:"✓"

	drawList
		let filteredGoods = getFilteredGoods
		div flex:1, display:flex, flexDirection:column, gap:style.gapBetweenBoxes, width:100%		
			for filteredGoods
				app.drawGoodBox .
